import { API } from '~apis/axios/instance';
import { ResponseBaseWithData } from '~types/response';

export default function updateAgreements(
  companyId: string,
  userId: string,
  companyAgreements: number[],
  userAgreements: number[],
) {
  return API.put<ResponseBaseWithData>(
    `/api/v2/companies/${companyId}/users/${userId}/agreements`,
    {
      data: {
        companyAgreements,
        userAgreements,
      },
    },
  );
}
